export default "__VITE_ASSET__f40161df__"